export var PRICE_TEXT_SURFACE;
(function(PRICE_TEXT_SURFACE) {
    PRICE_TEXT_SURFACE["PRODUCT_TILE"] = "product_tile";
    PRICE_TEXT_SURFACE["PDP"] = "pdp";
    PRICE_TEXT_SURFACE["QUICK_ADD_MODAL"] = "quick_add_modal";
    PRICE_TEXT_SURFACE["BRAND"] = "brand";
})(PRICE_TEXT_SURFACE || (PRICE_TEXT_SURFACE = {}));
